import config from '../../../config/config';
import getRequest from '../base/get';
import patchRequest from '../base/patch';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.subscription.accountApiUrl}api/cpo/v1/facility-account/list-accounts`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAccountsListFilters: (): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/cpo/v1/facility-account/list-filters`);
  },

  /**
   * Get the all data for export the Accounts list without pagination
   * @param {any} query - Query parameters for export data
   * @returns {any} Promise containing exported accounts data
   */
  exportData: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/cpo/v1/facility-account/export-accounts`, {
      ...parameters,
    });
  },
  /**
   * Fetch Account Details data show
   */
  fetchAccountAllList: (): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/account/account-names`, {});
  },
  /**
   * Approved the account function
   * @param {any} id - Account ID
   * @param {any} data - Approval payload
   * @returns {any} Promise containing approval response
   */
  approvedAccounts: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.subscription.accountApiUrl}api/cpo/v1/facility-account/verify-account/${id}`, {
      ...parameters,
    });
  },
};
